import { css } from 'styled-components';

export const defaultBoxShadow = css`
  box-shadow: 0 5px 12px 4px ${({ theme }) => theme.color.shadow_6}, 0 3px 6px 0 ${({ theme }) => theme.color.shadow_5},
    0 1px 2px -2px ${({ theme }) => theme.color.shadow_4};
`;
